import { render, staticRenderFns } from "./GButton.vue?vue&type=template&id=2c673037&"
import script from "./GButton.vue?vue&type=script&lang=js&"
export * from "./GButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports